import { CustomHttpClient, IRequestOptions } from './../../providers/CustomHttpClient';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Perfil } from '../../model/perfil';


@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(private http: CustomHttpClient) { }

  OnSearchTipoPerfil(idRessarcimento: number) {
    return this.http.Get("api/perfil/GetTipoPerfil/" + idRessarcimento);
  }

  OnSearchListaPerfil(idRessarcimento: string, idUsuario: string) {
    return this.http.Get("api/perfil/GetPerfil/" + idRessarcimento + "/" + idUsuario);
  }

  CreateOrUpdate(profile: Perfil, idResponsavel: number) {
    let param = new HttpParams().append("idResponsavel", idResponsavel.toString());
    return this.http.Post("api/perfil/CreateOrUpdate", profile, { params: param });
  }

  Delete(idPerfil: number, idResponsavel: number) {
    return this.http.Get("api/perfil/Delete/" + idPerfil + "/" + idResponsavel);
  }

  GetPerfil(idPerfil: number) {
    return this.http.Get("api/perfil/Get/" + idPerfil);
  }
  GetPerfilHash(hash: string) {
    return this.http.Get("api/perfil/GetHash/" + hash);
  }
}
